export interface modelObject {
    buttonName:string;
    client:number;
    csvFields: string[];
    currentFiles: string[];
    doc2sector: [number, number][];
    docCategory: number;
    docInventarNumber: string;
    docNetLocation: number;
    docVersionNumber:string;
    emailReceiverFurther: string;
    errorArray: Record<string,any>;
    event: string|number;
    fChildrenName:Record<string,any>;
    fVisitor: Record<string,any>;
    files: Record<string,any>;
    filesUpload: Record<string,any>;
    firstname: string;
    freeText: string;
    furtherEmailReceiver: Record<string,any>;
    furtherJobs: Record<string,any>;
    housenumber: string;
    jobSector: Record<string,any>;
    newFile: boolean|number;
    paramEmailArr: Record<string,any>;
    password: string;
    previewText: string;
    product: string;
    startdate: Date;
    street: string;
    swbWebType: string|number;
}

export function modelFunc(): modelObject {
    const model: modelObject = {
        buttonName: '',
        client: 1,
        csvFields: [],
        currentFiles: ["Tisch.pdf", "Kerzenleuchter.pdf", "Stuhl.jpg"],
        doc2sector: [[0,0]],
        docCategory: 1,
        docInventarNumber: '001',
        docNetLocation: 1,
        docVersionNumber: '001',
        emailReceiverFurther: '',
        errorArray: [],
        event: 0,
        fChildrenName: [['','']],
        fVisitor: [null],
        files: [],
        filesUpload: [],
        firstname: '',
        freeText: 'Dies ist ein Freitext',
        furtherEmailReceiver: [''],
        furtherJobs: [['','']],
        housenumber: '',
        jobSector: [[20,238]],
        newFile: false,
        paramEmailArr: [''],
        password: '',
        previewText: '<h2> Dies ist ein preview Field</h2><ul><li>Da kommt ganz viele Rein</<li></ul>',
        product: '',
        startdate: new Date('2027-03-03 13:14:32'),
        street: '',
        swbWebType: '',
    }
    return model as modelObject;
}